import React, { useEffect, useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import ReactInputMask from "react-input-mask";
import {VacancyFilterType} from "../Candidats";

type Props = {
  afterFilter?: (params?: VacancyFilterType, page?: number) => Promise<void>;
  formFilters: VacancyFilterType
  setFormFilters: React.Dispatch<any>
};

const VacancyFilter = (props: Props) => {
  const { t } = useTranslation();
  const {formFilters, setFormFilters} = props
  const [show, setShow] = useState<boolean>(false);


  useEffect(() => {
    document.addEventListener('click', (e) => {
      let target = e.target as HTMLElement;
      let filterContainer = document.querySelector('.filter-container');
      let filterToggle = document.querySelector('#filter-toggle');
      if (
        !filterContainer?.contains(target) &&
        !filterToggle?.contains(target) &&
        filterToggle !== target
      ) {
        setShow(false);
      }
    });
  }, []);
  const handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormFilters((prev: VacancyFilterType) => ({ ...prev, [name]: value }));
  };

  const update = async (isClear?: boolean) => {
    if (!props.afterFilter) return
    const filter = isClear ? {} : formFilters
    await props.afterFilter(filter, 1)
  };

  const resetFilter = () => {
    setFormFilters((prev: VacancyFilterType) => {
      const newFilters = { ...prev, email: '', phone: '' };

      setTimeout(() => props.afterFilter!(newFilters, 1), 0);

      return newFilters;
    });
  };


  const handleForm = (e: React.FormEvent) => {
    e.preventDefault();
    setShow(false);
    update();
  };

  return (
    <>
      <div className='filter'>
        <Button id='filter-toggle' onClick={() => setShow((prev) => !prev)}>
          {t('filter.filter')}
        </Button>
        {show && (
          <div className='filter-container shadow'>
            <h5>{t('filter.searchByFilter')}</h5>
            <form onSubmit={handleForm}>
              <div className='form-group'>
                <label className='form-label'>{'Почта'}</label>
                <input
                  type='text'
                  name="email"
                  className='form-control mb-3'
                  value={formFilters.email}
                  onChange={handleChangeInput}
                />
              </div>

              <label className='form-label'>{t('Телефон')}</label>
              <Form.Control
                className="form-control"
                name="phone"
                value={formFilters.phone}
                onChange={handleChangeInput}
              />

              <Button type='submit' className='mt-2'>
                {t('filter.find')}
              </Button>
              <Button
                type='button'
                variant='secondary'
                className='mt-2 ms-2'
                onClick={resetFilter}
              >
                {t('filter.reset')}
              </Button>
            </form>
          </div>
        )}
      </div>
    </>
  );
};

export default observer(VacancyFilter);
